<template>
  <div>
 

  <div class="min-h-screen bg-gray-50 py-8">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="bg-white shadow-lg rounded-lg p-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">{{ $t('legal.title') }}</h1>
        
        <div class="space-y-8">
          <!-- Éditeur -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Éditeur</h2>
            <p class="text-gray-600">
              {{ $t('legal.description') }}
            </p>
          </section>

          <!-- Hébergement -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Hébergement</h2>
            <p class="text-gray-600">
              Ce site est hébergé sur des serveurs sécurisés.<br>
              [Détails de l'hébergeur si nécessaire]
            </p>
          </section>

          <!-- Propriété intellectuelle -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Propriété Intellectuelle</h2>
            <p class="text-gray-600">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
              Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>
          </section>

          <!-- Protection des données -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Protection des Données</h2>
            <p class="text-gray-600">
              Les données personnelles collectées sur ce site sont traitées conformément au Règlement Général sur la Protection des Données (RGPD). 
              Vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
            </p>
          </section>

          <!-- Cookies -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Cookies</h2>
            <p class="text-gray-600">
              Ce site utilise des cookies techniques nécessaires à son fonctionnement. 
              Aucun cookie de tracking ou publicitaire n'est utilisé.
            </p>
          </section>

          <!-- Responsabilité -->
          <section>
            <h2 class="text-xl font-semibold text-gray-800 mb-4">Responsabilité</h2>
            <p class="text-gray-600">
              Les informations contenues sur ce site sont fournies à titre informatif. 
              L'éditeur s'efforce d'assurer l'exactitude des informations mais ne peut garantir qu'elles soient exemptes d'erreurs.
            </p>
          </section>
        </div>

        <div class="mt-8 pt-6 border-t border-gray-200">
          <p class="text-sm text-gray-500">
            Dernière mise à jour : {{ new Date().toLocaleDateString('fr-FR') }}
          </p>
        </div>
      </div>
    </div>


  </div> 

    <!-- Footer -->
    <AppFooter />
  </div>
</template>

<script lang="ts">
import AppFooter from '@/components/UI/AppFooter.vue';

import { defineComponent } from "vue";

export default defineComponent({
  name: "Legal",
  components: {
    AppFooter
  }
});
</script>
